import NoticeRedSmallIconPath from "@ingka/ssr-icon/paths/notice-red-small";

export default NoticeRedSmallIconPath;
